import React, { useMemo, useState } from 'react'
import { Drawer, DatePicker, Dropdown, Menu, Tabs } from 'antd'
import { Route, Switch, useHistory, Link, useParams } from 'react-router-dom'
import Creatable from 'react-select/creatable'
import Select from 'react-select'
import pluralize from 'pluralize'
import moment from 'moment'

import { AiFillDelete, AiOutlineDelete, AiOutlineDown } from 'react-icons/ai'

import { useToggle, usePet, server, useListData, normalize } from '../../modules'

import POItem from './poItem'


const { TabPane } = Tabs

const AddItemToPO = ({onClose, path }) => {
    const {id} = useParams();

    const [item, setItems] = useState([])
    const [string, setString] = useState('')
    const [index, setIndex] = useState(0)
   
    const history = useHistory()

    const [visible, toggleVisible] = useToggle(false)

    useMemo(() => setTimeout(toggleVisible, 100), [])

    const viewItem = i => {
        setIndex(i)
        setTimeout(() => history.push(`${path}/newItem/${i}`), 300)
    }

    const save = (val, i) => {
        console.log("Adding new item to po...")
        let temp = [...item]
        temp[i] = {
            ...temp[i],
            ...val
        }
        setItems(temp)
    }

    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }
    
    const onComplete = ({}, notif, ops) => {
        notif('New Items have been Added', ops('success'))
        onClose()
        close()
    }

    const removeItem = i => setItems(itms => itms.filter((_, x) => x !== i))

    console.log("logging item")
    console.log(item)

    const [{ loading: newLoading }, addItem] = usePet('addItemToPO', {
        id: id,
        items: item.map(({ item, name, qty, unit, price, discount, vat }) => ({
                item: item?._id, 
                itemName: name, 
                quantity: qty, 
                unit, 
                vat, 
                discount, 
                unitPrice: price
            }))
        }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Adding Item To Purchase Order...' } })
    

    const getCount = itm => Number(itm?.bulk * itm?.contains) === Number(itm?.contains) ? Number(itm?.bulk * itm?.contains) : Number(itm?.bulk)

    const newItm = () => {
        setItems(itms => {
            return [
                ...itms,
                {
                    name: `Item ${item.length + 1}`,
                    unit: 'Units',
                    qty: 1,
                    discount: 0,
                    price: 1,
                    vat: 0
                }
            ]
        })
    }
    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button className="text-white mr-2 hisani-btn-green font-medium rounded-lg text-sm px-5 py-2.5 text-center" onClick={ addItem }>Add New Item To Purchase Order</button>
                </div>
            }
            width="60%">
            <p className="font-extrabold text-3xl mb-0">Add New Item</p>
            {
                <Tabs>
                    <TabPane tab="Items" key="1">
                        {
                            item?.length > 0 ?
                                <>
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2 pl-4 text-center">
                                                    <div className="font-semibold">No.</div>
                                                </th>
                                                <th className="p-2 text-left">
                                                    <div className="font-semibold">Item</div>
                                                </th>
                                                <th className="p-2 text-left">
                                                    <div className="font-semibold">Quantity</div>
                                                </th>
                                                <th className="p-2 text-left">
                                                    <div className="font-semibold">Unit Price</div>
                                                </th>
                                                <th className="p-2 text-left">
                                                    <div className="font-semibold">Discount</div>
                                                </th>
                                                <th className="p-2 text-left">
                                                    <div className="font-semibold">VAT</div>
                                                </th>
                                                <th className="p-2 text-left">
                                                    <div className="font-semibold">Total</div>
                                                </th>
                                                <th className="p-2 text-left">
                                                    <div className="font-semibold"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                item.map((itm, key) =>
                                                    <tr>
                                                        <td className="p-2 h-5 text-center">{key + 1}</td>
                                                        <td className="p-2 h-5">
                                                            <div className="">{itm?.name}</div>
                                                        </td>
                                                        <td className="p-2 h-5">
                                                            <div className="">{Number(itm?.qty) } {pluralize(itm?.unit, itm?.qty)}</div>
                                                        </td>
                                                        <td className="p-2 h-5">
                                                            <div className="">Ksh. {itm?.price}</div>
                                                        </td>
                                                        <td className="p-2 h-5">
                                                            <div className="">Ksh. {itm?.discount}</div>
                                                        </td>
                                                        <td className="p-2 h-5">
                                                            <div className="">{itm?.vat}%</div>
                                                        </td>
                                                        <td className="p-2 h-5">
                                                            <div className="text-left">Ksh. {normalize(itm?.qty * itm?.price)}</div>
                                                        </td>
                                                        <td className="p-2 h-5">
                                                            <button onClick={() => viewItem(key)} className="btn py-1 shadow-none bg-gray-100 hover:bg-gray-200 hover:text">View</button>
                                                            <button onClick={() => removeItem(key)} className="btn ml-2 py-1 shadow-none bg-red-100 hover:bg-red-200 hover:text">
                                                                <AiOutlineDelete className='font-base' />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    <div className="w-full py-5 text-center">
                                        <button onClick={ newItm } className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text">Add New Item</button>
                                    </div>
                                    <div className="flex flex-col items-end pr-3 py-3">
                                        <p className="font-semibold text-lg underline mb-2">Overview</p>
                                        <p className="mb-1">Before Discount: Ksh. {normalize(item?.reduce((total, itm) => total + (itm?.price * itm?.qty), 0))}</p>
                                        <p className="mb-1">Discount: Ksh. {normalize(item?.reduce((total, itm) => total + (itm?.discount * itm?.qty), 0))}</p>
                                        <p className="mb-1">VAT: Ksh. {normalize(item?.reduce((total, itm) => total + (((itm?.price - itm?.discount) * itm?.qty) * (itm?.vat / 100)), 0))}</p>
                                        <p className="mb-1">Total: Ksh. {normalize(item?.reduce((total, itm) => total + ((itm?.price - itm?.discount) * itm?.qty * ((100 + itm?.vat) / 100)), 0))}</p>
                                    </div>
                                </>
                                :
                                <div className="w-full h-16 text-center">
                                    <button onClick={ newItm } className="btn py-2 px-3 text-base shadow-none bg-gray-100 hover:bg-gray-200 hover:text">Add New Item</button>
                                </div>
                        }
                    </TabPane>
                </Tabs>
            }
            <Switch>
                <Route path={ `${path}/newItem/:index` }>
                <POItem onSave={save} record={item[index]} />
                </Route>
            </Switch>
        </Drawer>
    )
}

export default AddItemToPO